import { render, staticRenderFns } from "./tmp-company-info.vue?vue&type=template&id=6b220341&"
import script from "./tmp-company-info.vue?vue&type=script&lang=js&"
export * from "./tmp-company-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports